import { useState } from 'react';
import {Row, Form, ToggleButton} from 'react-bootstrap';

function IminioTextField({ 
    id,
    label, 
    size, 
    placeholder, 
    defaultValue="", 
    type, 
    innerRef,  
    textAlign = 'start',
    readOnly,
    disabled,
    onKeyUp=()=>{},
    onChange=()=>{} 
}) {

    const [showPassword, setShowPassword] = useState(false)

    return <Row style={{position:'relative'}}>
            <Form.Control 
                id={id}
                className="iminio-border-round-force width-100 px-3" 
                type={showPassword===true?'text':type} 
                ref={innerRef} 
                placeholder={placeholder} 
                defaultValue={defaultValue}
                onChange={onChange} 
                readOnly={readOnly}
                disabled={disabled}
                onKeyUp={onKeyUp}
                style={{
                    textAlign: textAlign
                }}
            />
            {
                type!=='password'? '' :
            <ToggleButton
                type="checkbox"
                checked={showPassword}
                className="transparent fg-text iminio-password-show-button"
                variant="orange"
                onClick={(e) => setShowPassword(!showPassword)}
                >
                    {
                        showPassword===true ? 
                        <i className="mdi mdi-eye-closed text-12"></i>
                        :
                        <i className="mdi mdi-eye text-12"></i>
                    }
            </ToggleButton>}
    </Row>;
}

export default IminioTextField